module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/photos/term-bg-2-1878e335889640f312b6b311f6e1fa80.jpg";